export function getUserDevice() {
    const nua = typeof navigator !== 'undefined' ? navigator.userAgent : '';

    const isAndroid = /android/i.test(nua);
    const isIPhone = /iPhone|iPod/.test(nua);
    const isIPad = /iPad/.test(nua) || (typeof navigator !== 'undefined' && navigator.maxTouchPoints > 1 && /Macintosh/.test(nua));
    const isIos = isIPhone || isIPad;

    return { isIos, isAndroid };
}